// Webpack Imports
import * as bootstrap from 'bootstrap';


( function ($) {
	// 'use strict';

	// NAV Dropdowns Hover behaviour START
	const $dropdown = $('.navbar-nav .dropdown');
	const $dropdownToggle = $('.navbar-nav .dropdown-toggle');
	const $dropdownMenu = $('.navbar-nav .dropdown-menu');
	const showClass = 'show';

	$(window).bind('load resize', function() {
		if (this.matchMedia('(min-width: 992px)').matches) {
			$dropdown.hover(
				function() {
					const $this = $(this);
					$this.addClass(showClass);
					$this.find($dropdownToggle).attr('aria-expanded', 'true');
					$this.find($dropdownMenu).addClass(showClass);
				},
				function() {
					const $this = $(this);
					$this.removeClass(showClass);
					$this.find($dropdownToggle).attr('aria-expanded', 'false');
					$this.find($dropdownMenu).removeClass(showClass);
				}
			);

			// Little hack to make dropdown links clickable as we have hover functionality
			$dropdownToggle.on('click', function() {
				if ($(this).attr('href') && $(this).attr('href') != '#') {
					location.href = $(this).attr('href');
				}
			});
		} else {
			$dropdown.off('mouseenter mouseleave');
			$dropdownToggle.attr('href', '#');
		}

	});

	$('.navbar-toggler').click(function(){
		$('#navbar-toggle-icon').toggleClass('open');
	});

	// handle collapse megamenus on small screens
	if(window.matchMedia('(max-width: 992px)').matches) {
		$(document).click(function() {
			$('#header-nav .dropdown-menu.collapse.show').collapse('hide');
		});
	}
	// NAV Dropdowns Hover behaviour START

	// Youtube embeded videos handler START
	//generates random id helper
	function guid() {
		return '_' + Math.random().toString(36).substr(2, 9);
	}

	function generateIframe(div) {
		var playerElements = document.getElementsByClassName('js-play-video');
		for (var n = 0; n < playerElements.length; n++) {
			var iframe = document.createElement('iframe');
			iframe.setAttribute(
				"src",
				"https://www.youtube.com/embed/" + div.dataset.id + "?feature=oembed&autoplay=1"
			);
			iframe.setAttribute('frameborder', '0');
			iframe.setAttribute('allowfullscreen', '1');
			iframe.setAttribute(
				'allow',
				'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
			);
			div.parentNode.appendChild(iframe);
			div.style.display = 'none';
		}
	}

	function initYouTubeVideos() {
		var playerElements = document.getElementsByClassName('js-play-video');
		for (var n = 0; n < playerElements.length; n++) {
			var videoId = playerElements[n].dataset.id;
			var div = document.createElement('div');
			div.id = guid();
			div.setAttribute('data-id', videoId);
			div.setAttribute('class', 'slide-overlay');
			var videoTitle = document.createElement('h4');
			videoTitle.innerText = playerElements[n].dataset.heading;
			div.appendChild(videoTitle);
			div.onclick = function () {
				generateIframe(this);
			};
			playerElements[n].appendChild(div);
		}
	}

	document.addEventListener('DOMContentLoaded', initYouTubeVideos);
	// Youtube embeded videos handler END

	// Armored Cars carousel init START
	if( $('.armored-carousel').length ) {
		$('.armored-carousel').slick({
			infinite: false,
			variableWidth:true,
			nextArrow: '.sliderNextBtn',
			prevArrow: '.sliderPrevBtn',
		});
	}
	// Armored Cars carousel init END
	// Related Articles carousel init START
	if ( $('.related-articles-carousel').length ) {
		$('.related-articles-carousel').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			dots: true,
			autoplay: true,
			autoplaySpeed: 10000,
			arrows: true,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						arrows: false,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						arrows: false,
					}
				}
			]
		});
	}
	// Related Articles carousel init END
	// Single Car carousel init START
	if( $('.car-gallery-carousel').length && $('.car-gallery-thumbnails').length ) {
		$('.car-gallery-carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			fade: true,
			autoplay: true,
			autoplaySpeed: 10000,
			asNavFor: '.car-gallery-thumbnails'
		});
		$('.car-gallery-thumbnails').slick({
			slidesToShow: 7,
			slidesToScroll: 1,
			asNavFor: '.car-gallery-carousel',
			arrows: false,
			focusOnSelect: true,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 6,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 4,
					}
				}
			]
		});
	}
	// Single Car carousel init END

	// Enable Tooltips
	var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
	var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
		return new bootstrap.Tooltip(tooltipTriggerEl)
	});

	// Play Youtube Videos in BS Modal layout START
	if( $('.videos-collection').length ) {
		var videoModal = document.getElementById('videoModal');
		var srcId;
		var videoIframe = document.getElementById('videoIfame');
		// Gets the video src from the dataid-src on each trigger
		$('.js-modal-video').click(function() {
			srcId = $(this).data( 'srcid' );
		});

		videoModal.addEventListener('shown.bs.modal', function (event) {
			videoIframe.setAttribute(
				"src",
				"https://www.youtube.com/embed" + srcId + "?feature=oembed&autoplay=1"
			);
			videoIframe.setAttribute('frameborder', '0');
			videoIframe.setAttribute('allowfullscreen', '1');
			videoIframe.setAttribute(
				'allow',
				'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
			);
		})
		// stop playing the youtube video when I close the modal
		videoModal.addEventListener('hide.bs.modal', function (event) {
			videoIframe.removeAttribute('src');
			videoIframe.removeAttribute('frameborder');
			videoIframe.removeAttribute('allowfullscreen');
			videoIframe.removeAttribute('allow');
		});
	}
	// Play Youtube Videos in BS Modal layout START

	// TOC functionality for Single Posts START
	function convertToSlug(Text) {
		return Text
			.trim()
			.toLowerCase()
			.replace(/[^a-z0-9-]/gi, '-')
			.replace(/-+/g, '-')
			.replace(/^-|-$/g, '')
		;
	}

	function generateArticleToc() {
		let tocStr = '<div class="article-toc_wrap"><h4>In this article</h4><ul class="toc-list">';

		let subtitles = $('.main-article_content h2');

		if( !subtitles.length) return;

		for(let i=0; i<subtitles.length; i++) {
			subtitles[i].setAttribute('id', convertToSlug(subtitles[i].textContent));
			tocStr += '<li><a href="#'+convertToSlug(subtitles[i].textContent)+'">'+ subtitles[i].textContent + '</a></li>';
		}

		tocStr +='</ul></div></div>';

		$('.main-article_content').before('<div class="col-lg-3 sidebar d-none d-lg-block">'+tocStr+'</div>');
		$('.post-content').before(tocStr);
	}

	if($('body').hasClass('single-post')) {
		generateArticleToc();
	}

	// Smooth Scroll to title anchor
	// Select all TOC links with hashes
	$('.toc-list a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
		// On-page links
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			// Figure out element to scroll to
			let target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			let scrollOffset = $('#header-nav').height() + 50;

			// Does a scroll target exist?
			if (target.length) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				$('html, body').animate({
					scrollTop: target.offset().top - scrollOffset
				}, 800, function() {
					// Callback after animation
					// Must change focus!
					let $target = $(target);
					$target.trigger('focus');
					if ($target.is(":focus")) { // Checking if the target was focused
						return false;
					} else {
						$target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
						$target.focus(); // Set focus again
					};
				});
			}
		}
	});

	function highlightNavigation() {
		// Highlight TOC item when corresponding section in view
		var $tocNavLinks = $('.toc-list a');
		var $tocSections = $($(".main-article_content h2").get().reverse());
		
		// console.log($tocSections);
		// map each section id to their corresponding navigation link
		var sectionIdTonavigationLink = {};
		$tocSections.each(function() {
			var id = $(this).attr('id');
			sectionIdTonavigationLink[id] = $('.toc-list a[href=\\#' + id + ']');
		});
		// get the current vertical position of the scroll bar
		var scrollPosition = $(window).scrollTop() + 400;
		// iterate the sections
		$tocSections.each(function() {
			var currentSection = $(this);
			// get the position of the section
			var sectionTop = currentSection.offset().top;
			// if the user has scrolled over the top of the section
			if (scrollPosition >= sectionTop) {
				// get the section id
				var id = currentSection.attr('id');
				// get the corresponding navigation link
				var $navigationLink = sectionIdTonavigationLink[id];
				// if the link is not active
				if (!$navigationLink.hasClass('active')) {
					// remove .active class from all the links
					$tocNavLinks.removeClass('active');
					// add .active class to the current link
					$navigationLink.addClass('active');
				}
				// we have found our section, so we return false to exit the each loop
				return false;
			}
		});
	}
	// if have TOC, fire scroll highlight on desktop
	if( $('.toc-list').length  && $(window).width() > 991 ) {
		$(window).scroll( highlightNavigation );
	}
	// TOC functionality for Single Posts END
	// trigger links in select dropdowns on Cars archive page START
	$('#vehicle-type-dropdown, #vehicle-brand-dropdown').on('change', function () {
		var url = $(this).val(); // get selected value
		if(url) { // require a URL
				window.location = url; // redirect
		}
		return false;
	});
	// trigger links in select dropdowns on Cars archive page END

	// Gallery Flexible Content Block slider START
	if( $('.flexi-gallery-carousel').length && $('.flexi-gallery-thumbs').length ) {
		$('.flexi-gallery-carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			fade: true,
		})
		.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			$('.thumb-control[data-index = ' + currentSlide + ']').removeClass('current');
			$('.thumb-control[data-index = ' + nextSlide + ']').addClass('current');
		});

		$(document).on('click','.flexi-gallery-thumbs .thumb-control',function(){
			var scrollIndex = $(this).data('index');
			$('.flexi-gallery-carousel').slick('slickGoTo', scrollIndex);
		});
	}
	// Gallery Flexible Content Block slider END
	// Flexi Cars carousel init START
	if( $('.flexi-cars-carousel-wrap').length ) {
		$('.flexi-cars-carousel-wrap').slick({
			dots: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			nextArrow: '.flexiCarouselNext',
			prevArrow: '.flexiCarouselPrev',
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	}
	// Flexi Cars carousel init END
	// Text Carousel START
	if( $('.text-carousel').length ) {
		$('.text-carousel').slick({
			arrows: false,
			dots: true,
			fade: true,
			autoplay: true,
			autoplaySpeed: 3500,
		});
	}
	// Text Carousel END


	$(document).ready(function () {

		// Mobile menu open animation START
		// Close mobile menu if window width is more than 991px
		$(window).resize(function() {
			if ($(window).width() > 991) {
				$('html').removeClass('js-mobile-menu-open');
				$('#navbar').removeClass('show');
				$('.navbar-toggler').addClass('collapsed');
				$('.navbar-toggler').attr('aria-expanded', 'false');
				$('.toggler-icon').removeClass('open');
			}
		});

		// add closing class function
		function addClosingClass() {
			$('html').addClass('js-closing');
			setTimeout(function() {
				$('html').removeClass('js-closing');
			}, 800);
		}

		// close mobile menu
		$('.navbar-toggler').click(function() {
			if ($('html').hasClass('js-mobile-menu-open')) {
				addClosingClass(); // Add js-closing class when js-mobile-menu-open is removed
			}
		});

		// toggle class for open and close mobile menu
		$('.navbar-toggler').click(function() {
			if ($(window).width() < 991) {
				$('html').toggleClass('js-mobile-menu-open');
			}
		});
		// Mobile menu open animation END

	});
} )(jQuery);